import SeoLanding from "../components/SeoLanding";

export default function SchoolIdCard() {
    return (
        <SeoLanding
            slug="school"
            keyword="school id card maker"
            audience="schools"
            seoTitle="School ID Card Maker — Bulk Print Student ID Cards | IDCardGen"
            seoDescription="Free online school ID card maker for Indian schools. Excel bulk import, drag-and-drop editor, print-ready PDF (8 cards per A4) and PVC export. Free trial."
            h1="The fastest |school ID card maker| for Indian schools."
            intro="Generate hundreds of professional student ID cards from a single Excel sheet. Bulk photo mapping, custom templates, watermark-free PDF export — built for school admins, not designers."
            features={[
                {
                    title: "Bulk import from Excel",
                    body: "Upload class roster + photos folder. We auto-match by SrNo or filename — 500 cards in 30 seconds.",
                },
                {
                    title: "School-ready templates",
                    body: "Pre-built layouts for primary, secondary and CBSE / state board ID standards. Add school logo & principal sign.",
                },
                {
                    title: "Print-ready PDF",
                    body: "8 cards per A4 page, perfectly aligned for cutting. Or export individual PNGs for online PVC printers.",
                },
                {
                    title: "Hindi / regional fonts",
                    body: "Render student names in Devanagari, Tamil, Telugu, Bengali — Unicode safe in both PDF and print.",
                },
                {
                    title: "QR & barcode",
                    body: "Encode admission number or attendance URL into a QR / Code-128 barcode on every card.",
                },
                {
                    title: "Reusable templates",
                    body: "Save once, regenerate every academic year with a fresh Excel — no redesigning.",
                },
            ]}
            faqs={[
                {
                    q: "How many student ID cards can I generate at once?",
                    a: "There is no hard limit. Schools regularly export 500–2000 cards per session. Larger batches use slightly lower image resolution to keep memory safe.",
                },
                {
                    q: "Can I print on PVC cards?",
                    a: "Yes. Export individual PNGs at the standard CR80 (85.6 × 54 mm) size and send them to any local PVC printing service, or use the A4 PDF for paper / lamination.",
                },
                {
                    q: "Do you charge per card?",
                    a: "Packages are pay-once for a credit pool — for example, ₹50 for 50 cards under the Starter plan. The free trial gives 20 watermarked cards to evaluate.",
                },
                {
                    q: "Can I add the school logo and principal signature?",
                    a: "Yes — upload PNG / JPG for the logo and signature, position them on the template, and they will appear on every generated card.",
                },
                {
                    q: "Does it work on mobile?",
                    a: "The editor is desktop-optimised, but exports and template management work fully on tablets and large phones.",
                },
            ]}
        />
    );
}
